<template>
  <div class="czzn-nssb">
    <div class="czsc-con">
      <div class="czsc-nr-tit">【纳税申报】</div>
      <p>纳税申报是对已生成的财务报表一键自动导入山西省电子税务局中，并完成财务报表的申报，还提供了财务报表申报情况查询和电子税务局快捷登录入口，方便纳税人完成其他各项申报工作。</p>
      <p>1、首次进行财务报表申报时，需录入申报密码、手机号及验证码信息；</p>
      <img src="@/assets/images/czzn_052.png" />
      <p>2、选择号申报类型、年度、期间，点击图中的【导入电子税务局】，即可完成财务报表的上传；</p>
      <img src="@/assets/images/czzn_053.png" />
      <p>3、财务报表上传成功以后，点图中的【进行申报】，即可完成财务报表的申报；</p>
      <img src="@/assets/images/czzn_054.png" />
      <p>4、点左侧菜单中的申报查询可以查询整个年度内财务报表的申报情况；</p>
      <img src="@/assets/images/czzn_055.png" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'czzn_nssb',
};
</script>
